import classNames from 'classnames';
import Text from '../atoms/text';

export interface TableColumn<T> {
	key: keyof T;
	label: string;
	width?: string;
	children?: (row: T, index?: number) => JSX.Element | JSX.Element[];
}

export interface TableProps<T> {
	data: T[];
	columns: TableColumn<T>[];
	onActionsViewClick?: (index: number) => void;
	onActionsEditClick?: (index: number) => void;
	className?: string;
	shouldHide?: boolean;
}

const Table = <T,>({
	shouldHide = true,
	columns,
	data,
	className,
}: TableProps<T>) => {
	return (
		<div className={classNames('grid grid-flow-row w-full', className)}>
			{/* Cabeçalho */}
			<div className="contents">
				{columns.map((column, index) => (
					<div
						key={index}
						className={classNames(
							'px-4 py-2 text-left bg-gray-border font-bold border-b border-gray-border'
							// {
							// 	'hidden sm:block':
							// 		shouldHide &&
							// 		index !== 0 &&
							// 		index !== columns.length - 1,
							// }
						)}
					>
						{column.label}
					</div>
				))}
			</div>

			{/* Corpo */}
			{data.map((row, rowIndex) => (
				<div className="contents" key={rowIndex}>
					{columns.map((column, colIndex) => (
						<div
							key={colIndex}
							className={classNames(
								'px-4 py-3 text-sm border-b border-gray-border',
								{
									// 'hidden sm:block':
									// 	shouldHide &&
									// 	colIndex !== 0 &&
									// 	colIndex !== columns.length - 1,
									'bg-gray-bg text-gray-label':
										(data[rowIndex] as any).isActive ==
										false,
								}
							)}
						>
							{column.children ? (
								column.children(row, rowIndex)
							) : (
								<Text className="text-xs leading-none">
									{row[column.key] as string}
								</Text>
							)}
						</div>
					))}
				</div>
			))}
		</div>
	);
};

export default Table;
